import useUser from "../../../api/api-hooks/auth/useUser";

export function NewConversationMessage() {
  const { user } = useUser();

  return (
    <div className="tw:w-full tw:flex tw:flex-col tw:items-center tw:justify-center tw:p-4">
      <img src={"/img/GCLogo.png"} className="tw:w-12 tw:h-12" />
      <h4 className="text-dark text-center tw:font-semibold">
        Hello {user?.Name?.split(" ")?.[0]}!<br /> How can I help you today?
      </h4>
    </div>
  );
}
